import { createStore } from 'vuex';

// Vue.use(Vuex);
const requireContext = import.meta.glob('./modules/*.js', { eager: true });

// Transform the imported modules into a Vuex-compatible format
const modules = Object.entries(requireContext).reduce((modules, [filePath, module]) => {
    // Extract the name of the module from the file path
    const moduleName = filePath.replace(/(^\.\/modules\/)|(\.js$)/g, '');

    // Ensure the module is namespaced
    if (module.default.namespaced === undefined) {
        module.default.namespaced = true;
    }

    // Add the module to the modules object
    return { ...modules, [moduleName]: module.default };
}, {});

export default createStore({ modules });
